//  Error logging for Cardholder Portal Application
import {
  generateErrorLogger,
  consoleErrorTransport,
} from 'shared-components/src/utils/errors';

const errorLogger = generateErrorLogger('CardholderPortal', consoleErrorTransport);

export { errorLogger };
